import type { ComponentProps } from "react";

import { SvgSlot } from "@/shared/ui/common";

export const MapPointIcon = (props: ComponentProps<typeof SvgSlot>) => (
  <SvgSlot {...props}>
    <svg
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.16666 7.26211C2.16666 3.9961 4.77 1.33325 7.99999 1.33325C11.23 1.33325 13.8333 3.9961 13.8333 7.26211C13.8333 8.83885 13.384 10.5319 12.5896 11.9945C11.7962 13.4553 10.6371 14.7247 9.187 15.4025C8.4337 15.7546 7.56628 15.7546 6.81298 15.4025C5.3629 14.7247 4.20374 13.4553 3.41036 11.9945C2.61601 10.5319 2.16666 8.83885 2.16666 7.26211ZM7.99999 2.33325C5.33894 2.33325 3.16666 4.53157 3.16666 7.26211C3.16666 8.66016 3.56841 10.1902 4.28913 11.5172C5.01082 12.8461 6.03067 13.933 7.23642 14.4966C7.72136 14.7233 8.27862 14.7233 8.76356 14.4966C9.96931 13.933 10.9892 12.8461 11.7109 11.5172C12.4316 10.1902 12.8333 8.66016 12.8333 7.26211C12.8333 4.53157 10.661 2.33325 7.99999 2.33325ZM7.99999 5.66659C7.17156 5.66659 6.49999 6.33816 6.49999 7.16659C6.49999 7.99501 7.17156 8.66659 7.99999 8.66659C8.82842 8.66659 9.49999 7.99501 9.49999 7.16659C9.49999 6.33816 8.82842 5.66659 7.99999 5.66659ZM5.49999 7.16659C5.49999 5.78587 6.61928 4.66659 7.99999 4.66659C9.3807 4.66659 10.5 5.78587 10.5 7.16659C10.5 8.5473 9.3807 9.66659 7.99999 9.66659C6.61928 9.66659 5.49999 8.5473 5.49999 7.16659Z"
      />
    </svg>
  </SvgSlot>
);
